import Title from '../components/title';
import Footer from '../components/footer';
import Subtitle from '../components/subtitle';
import Core from '../components/core';
import { ArrowLongDownIcon } from '@heroicons/react/20/solid'
import { ScrollRestoration } from "react-router-dom"

const navigation = [
    { id: 1, name: 'Nos recommandations', to: '/strategie-retraite/' , icon: ArrowLongDownIcon},
    { id: 2, name: 'Bilans retraite', to: '/bilan-retraite/' , icon: ArrowLongDownIcon},
    { id: 3, name: 'Articulation chômage / retraite', to: '/articulation-chomage-retraite/' , icon: ArrowLongDownIcon},
    { id: 4, name: 'Des solutions d\'optimisation', to: '/solutions-optimisation/' , icon: ArrowLongDownIcon},
    { id: 5, name: 'Etudes comparatives expatriation', to: '/retour-expatriation/' , icon: ArrowLongDownIcon},
    { id: 6, name: 'Des conférences spécifiques', to: '/nos-conferences/' , icon: ArrowLongDownIcon},
]

const context = [   
    {
        "title": "",
        "core": [
            {
                "subtitle": "",
                "text": <span> Nous pouvons vous accompagner pour la mise en place de vos dossiers de liquidation de retraite, pour les résidents en France et pour les résidents hors de France. </span>,
            },                       
        ]
    },
    {
        "title": "",
        "core": [
            {
                "subtitle": "",
                "text": <span> Dans ce cadre, nous vous envoyons la procédure pour préparer l'enregistrement de la demande de liquidation. </span>,
            },    
            {
                "subtitle": "",
                "text": <span> Nous pouvons également vous assister lors de la saisie de votre demande et vous proposer un suivi. </span>,
            },                   
        ]
    },
]

export default function Liquidation() { 
    return (
        <>
            <Title classNames="bg-liquidation bg-cover lg:bg-right bg-left" title="Liquidations de retraite" />

            <Subtitle subtitle="Notre accompagnement pour les liquidations de retraite" paragraph="" />      

            <Core navigation={navigation} context={context} />
  
            <Footer />

            <ScrollRestoration />
        </>
    )
}